/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { Space, Tooltip, Typography, Button } from 'antd';
import './styles/list-incidents.scss';
import Headers from './components/list-incidents/Headers';
import Filters from './components/list-incidents/Filters';
import { IFiltersIncidentsFormValues } from './interfaces';
import moment from 'moment';
import CreateIncidents from './components/list-incidents/CreateIncidents';
import { useAppSelector } from 'app/hooks';
import {
  loadingIncidentsAction,
  UNMOUT_INCIDENTS_LIST,
  updateIncidentFilterAction,
} from 'actions/incidents';
import { useHistory } from 'react-router';
import { FlagFilled } from '@ant-design/icons';
import { trim, get, has } from 'lodash';
import { renderImageResponseStatus } from './helpers';
import InfinityLoadTable from 'components/common/InfinityLoadTable';
import { isEmpty } from 'lodash';
import { translate } from 'libs';
import { useDispatch } from 'react-redux';
import ReactDragListView from 'react-drag-listview';
import { NoColumnsIcon, FilterIcon } from './components/list-incidents/images';
import { MenuOutlined } from '@ant-design/icons';

import { getSettingServeyAction } from 'actions/organization';
import { IPayloadGetSettingServey } from 'pages/setting/interfaces';
const ListIncidents = () => {
  const history = useHistory();

  const showHidden: boolean = useAppSelector(
    (state) => state.organizations.isShowHiddenOrganization
  );
  const myOrg = useAppSelector((state) => state.users.selectedOrg);
  const data_org_root = useAppSelector((state) => state.organizations.root_org_data);
  const { list, isLoading } = useAppSelector((state) => state.incidents);
  const [isVisibleCreate, setIsVisibleCreate] = React.useState<boolean>(false);

  const filtersRef: any = React.useRef();
  const [query, setQuery] = React.useState<any>(null);
  const [trigger, setTrigger] = React.useState(0);
  const [movingCol, setMovingCol] = React.useState<string>('');
  const filters = useAppSelector((state) => state.incidentsFilters);
  const [sortType, setSortType] = React.useState<string>(filters.sort_by || '');
  const [ascOrder, setAscOrder] = React.useState<boolean>(
    typeof filters.sort_order === 'number' ? filters.sort_order === 1 : true
  );
  const auth = useAppSelector((state) => state.auth);
  const [surveyStatus, setSurveyStatus] = React.useState<boolean>(true);
  const dispatch = useDispatch();

  const renderColTitle = (title: string, sort: string) => {
    return (
      <div className="table-header">
        <span
          className="dragHandler"
          onClick={(e) => {
            e.stopPropagation();
          }}
          onMouseOver={(e) => {
            setMovingCol(title);
          }}
          onMouseLeave={(e) => {
            setMovingCol('');
          }}
        >
          <>
            {movingCol === title && <MenuOutlined style={{ marginRight: '5px' }} />}
            {title}
          </>
        </span>
        <span
          className={sortType === sort ? (ascOrder === true ? 'upIcon' : 'downIcon') : 'normalIcon'}
        >
          {}
        </span>
      </div>
    );
  };

  const withLink = (columnConfig) => {
    if (!columnConfig) return null;
    const originalRender = columnConfig.render || ((text) => text);

    return {
      ...columnConfig,
      render: (text, record, index) => {
        const cellContent = originalRender(text, record, index);

        return (
          <a 
            href={`/admin/incidents/${record._id}`} 
            style={{ 
              display: 'block', 
              color: 'inherit',
              textDecoration: 'none' 
            }}
          >
            {cellContent}
          </a>
        );
      },
    };
  };

  const totalCols = new Map([
    [
      'sequence',
      {
        label: 'sequence',
        title: renderColTitle(translate('incidents.list.incident'), 'sequence'),
        dataIndex: 'sequence',
        width: 120,
        showSorterTooltip: false,
        ellipsis: {
          showTitle: false,
        },
        sorter: true,
        render: (sequence: number) => (
          <Tooltip placement="bottomLeft" title={sequence}>
            <Typography.Text className="txt-incident">{sequence}</Typography.Text>
          </Tooltip>
        ),
        // fixed: 'left',
      },
    ],
    [
      'sms',
      {
        label: 'sms',
        title: renderColTitle(translate('incidents.list.msgs'), 'response_status'),
        dataIndex: 'response_status',
        showSorterTooltip: false,
        sorter: true,
        width: 120,
        render: (_response_status: string, record: any) => {
          const totalMessage = record?.totalMessage;
          const { src, tooltip } = renderImageResponseStatus(record?.response_status, totalMessage);
          return (
            <Space>
              {src && (
                <Tooltip placement="bottomLeft" title={translate(`incidents.list.${tooltip}`)}>
                  <img alt="" src={src} />
                </Tooltip>
              )}
              <Typography.Text>{totalMessage || 0}</Typography.Text>
            </Space>
          );
        },
      },
    ],
    [
      'status',
      {
        label: 'status',
        title: renderColTitle(translate('incidents.list.status'), 'status'),
        dataIndex: 'status',
        width: 146,
        ellipsis: {
          showTitle: false,
        },
        showSorterTooltip: false,
        sorter: true,
        render: (status: any) => {
          return (
            <Tooltip placement="bottomLeft" title={status?.name}>
              <Typography.Text>{status?.name}</Typography.Text>
            </Tooltip>
          );
        },
      },
    ],
    [
      'description',
      {
        label: 'description',
        title: renderColTitle(translate('incidents.list.description'), 'description'),
        dataIndex: 'description',
        width: 250,
        ellipsis: {
          showTitle: false,
        },
        showSorterTooltip: false,
        sorter: true,
        render: (record: string) => {
          return (
            <Tooltip
              placement="bottomLeft"
              title={
                <span style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{record}</span>
              }
            >
              <span className="text-ellipsis">{record}</span>
            </Tooltip>
          );
        },
      },
    ],
    [
      'organization',
      {
        label: 'organization',
        title: renderColTitle(translate('incidents.list.org'), 'organization'),
        dataIndex: 'organization',
        width: 300,
        ellipsis: {
          showTitle: false,
        },
        showSorterTooltip: false,
        sorter: true,
        render: (_: any, record: any) => {
          const orgName: string = record?.org_id?.name;
          return (
            <Tooltip placement="bottomLeft" title={orgName}>
              {orgName?.length < 60 ? orgName : orgName.substring(0, 32) + `...`}
            </Tooltip>
          );
        },
      },
    ],
    [
      'updatedAt',
      {
        label: 'updatedAt',
        title: renderColTitle(translate('incidents.list.updated'), 'updatedAt'),
        dataIndex: 'updatedAt',
        width: 125,
        sorter: true,
        showSorterTooltip: false,
        ellipsis: {
          showTitle: false,
        },
        render: (record: string) => {
          const text: string = moment(record).format('YYYY/MM/DD');
          return (
            <Tooltip placement="bottomLeft" title={text}>
              {text}
            </Tooltip>
          );
        },
      },
    ],
    [
      'updatedAtDateTime',
      {
        label: 'updatedAtDateTime',
        title: renderColTitle(translate('incidents.list.updatedAtDateTime'), 'updatedAt'),
        dataIndex: 'updatedAt',
        width: 165,
        sorter: true,
        showSorterTooltip: false,
        ellipsis: {
          showTitle: false,
        },
        render: (record: string) => {
          const text: string = moment(record).format('YYYY/MM/DD HH:mm');
          return (
            <Tooltip placement="bottomLeft" title={text}>
              {text}
            </Tooltip>
          );
        },
      },
    ],
    [
      'submitted',
      {
        label: 'submitted',
        title: renderColTitle(translate('incidents.list.submitted'), 'createdAt'),
        dataIndex: 'createdAt',
        width: 125,
        sorter: true,
        showSorterTooltip: false,
        ellipsis: {
          showTitle: false,
        },
        render: (record: string) => {
          const text: string = moment(record).format('YYYY/MM/DD');
          return (
            <Tooltip placement="bottomLeft" title={text}>
              {text}
            </Tooltip>
          );
        },
      },
    ],
    [
      'submittedDateTime',
      {
        label: 'submittedDateTime',
        title: renderColTitle(translate('incidents.list.submittedAtDateTime'), 'createdAt'),
        dataIndex: 'createdAt',
        width: 165,
        sorter: true,
        showSorterTooltip: false,
        ellipsis: {
          showTitle: false,
        },
        render: (record: string) => {
          const text: string = moment(record).format('YYYY/MM/DD HH:mm');
          return (
            <Tooltip placement="bottomLeft" title={text}>
              {text}
            </Tooltip>
          );
        },
      },
    ],
    [
      'lastReceivedAt',
      {
        label: 'lastReceivedAt',
        title: renderColTitle(translate('incidents.list.lastReceivedAt'), 'last_received_at'),
        dataIndex: 'last_received_at',
        width: 180,
        sorter: true,
        showSorterTooltip: false,
        ellipsis: {
          showTitle: false,
        },
        render: (last_received_at: string, record: any) => {
          const value = last_received_at || record?.createdAt;
          if (!value) return null;
          const text: string = moment(value).format('YYYY/MM/DD HH:mm:ss');
          return (
            <Tooltip placement="bottomLeft" title={text}>
              {text}
            </Tooltip>
          );
        },
      },
    ],
    [
      'lastReceivedDate',
      {
        label: 'lastReceivedDate',
        title: renderColTitle(translate('incidents.list.lastReceivedDate'), 'last_received_at'),
        dataIndex: 'last_received_at',
        width: 140,
        sorter: true,
        showSorterTooltip: false,
        ellipsis: {
          showTitle: false,
        },
        render: (last_received_at: string, record: any) => {
          const value = last_received_at || record?.createdAt;
          if (!value) return null;
          const text: string = moment(value).format('YYYY/MM/DD');
          return (
            <Tooltip placement="bottomLeft" title={text}>
              {text}
            </Tooltip>
          );
        },
      },
    ],
    [
      'lastSentAt',
      {
        label: 'lastSentAt',
        title: renderColTitle(translate('incidents.list.lastSentAt'), 'last_sent_at'),
        dataIndex: 'last_sent_at',
        width: 180,
        sorter: true,
        showSorterTooltip: false,
        ellipsis: {
          showTitle: false,
        },
        render: (last_sent_at: string) => {
          if (!last_sent_at) return null;
          const text: string = moment(last_sent_at).format('YYYY/MM/DD HH:mm:ss');
          return (
            <Tooltip placement="bottomLeft" title={text}>
              {text}
            </Tooltip>
          );
        },
      },
    ],
    [
      'lastSentDate',
      {
        label: 'lastSentDate',
        title: renderColTitle(translate('incidents.list.lastSentDate'), 'last_sent_at'),
        dataIndex: 'last_sent_at',
        width: 140,
        sorter: true,
        showSorterTooltip: false,
        ellipsis: {
          showTitle: false,
        },
        render: (last_sent_at: string) => {
          if (!last_sent_at) return null;
          const text: string = moment(last_sent_at).format('YYYY/MM/DD');
          return (
            <Tooltip placement="bottomLeft" title={text}>
              {text}
            </Tooltip>
          );
        },
      },
    ],
    [
      'lastChatAt',
      {
        label: 'lastChatAt',
        title: renderColTitle(translate('incidents.list.lastChatAt'), 'last_chat_at'),
        dataIndex: 'last_chat_at',
        width: 180,
        sorter: true,
        showSorterTooltip: false,
        ellipsis: {
          showTitle: false,
        },
        render: (last_chat_at: string, record: any) => {
          const value = last_chat_at || record?.createdAt;
          if (!value) return null;
          const text: string = moment(value).format('YYYY/MM/DD HH:mm:ss');
          return (
            <Tooltip placement="bottomLeft" title={text}>
              {text}
            </Tooltip>
          );
        },
      },
    ],
    [
      'lastChatDate',
      {
        label: 'lastChatDate',
        title: renderColTitle(translate('incidents.list.lastChatDate'), 'last_chat_at'),
        dataIndex: 'last_chat_at',
        width: 140,
        sorter: true,
        showSorterTooltip: false,
        ellipsis: {
          showTitle: false,
        },
        render: (last_chat_at: string, record: any) => {
          const value = last_chat_at || record?.createdAt;
          if (!value) return null;
          const text: string = moment(value).format('YYYY/MM/DD');
          return (
            <Tooltip placement="bottomLeft" title={text}>
              {text}
            </Tooltip>
          );
        },
      },
    ],
    [
      'priority',
      {
        label: 'priority',
        title: renderColTitle(translate('incidents.list.priority'), 'priority'),
        dataIndex: 'priority',
        width: 150,
        ellipsis: {
          showTitle: false,
        },
        showSorterTooltip: false,
        sorter: true,
        render: (priority: any) => {
          const { name, color } = priority;
          return (
            <>
              {
                <Tooltip placement="bottomLeft" title={priority?.name}>
                  {!isEmpty(name) && !isEmpty(color) ? (
                    <FlagFilled style={{ color: priority?.color }} />
                  ) : (
                    <div></div>
                  )}
                </Tooltip>
              }
            </>
          );
        },
      },
    ],
    [
      'type',
      {
        label: 'type',
        title: renderColTitle(translate('incidents.detail.formDetail.label.type'), 'type'),
        dataIndex: 'type',
        width: 150,
        ellipsis: {
          showTitle: false,
        },
        showSorterTooltip: false,
        sorter: true,
        render: (type: any) => {
          if (!type) return null;
          const { name } = type;
          return (
            <>
              {
                <Tooltip placement="bottomLeft" title={type?.name}>
                  {name}
                </Tooltip>
              }
            </>
          );
        },
      },
    ],
    [
      'happendedAt',
      {
        label: 'happendedAt',
        title: renderColTitle(translate('incidents.detail.formDetail.label.date'), 'happened_at'),
        dataIndex: 'happened_at',
        width: 120,
        ellipsis: {
          showTitle: false,
        },
        showSorterTooltip: false,
        sorter: true,
        render: (happened_at: string) => {
          if (!happened_at) return null;
          const text = moment(happened_at).format('YYYY/MM/DD');

          return (
            <Tooltip
              placement="bottomLeft"
              title={
                <span style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{text}</span>
              }
            >
              <span className="text-ellipsis">{text}</span>
            </Tooltip>
          );
        },
      },
    ],
    [
      'assignees',
      {
        label: 'assignees',
        title: renderColTitle(translate('incidents.detail.share.assignee'), 'assignees'),
        dataIndex: 'assignees',
        width: 120,
        ellipsis: {
          showTitle: false,
        },
        showSorterTooltip: false,
        sorter: true,
        render: (assignees: any[]) => {
          if (!assignees.length) return null;
          const text = assignees.map((t) => t.full_name).join(', ');
          return (
            <Tooltip
              placement="bottomLeft"
              title={
                <span style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{text}</span>
              }
            >
              <span className="text-ellipsis"> {assignees.map((t) => t.full_name).join(', ')}</span>
            </Tooltip>
          );
        },
      },
    ],
    [
      'labels',
      {
        label: 'labels',
        title: renderColTitle(translate('incidents.detail.share.label'), 'labels'),
        dataIndex: 'labels',
        width: 150,
        ellipsis: {
          showTitle: false,
        },
        showSorterTooltip: false,
        sorter: true,
        render: (labels: any[]) => {
          if (!labels.length) return null;
          const text = labels.map((t) => t.name).join(', ');
          return (
            <Tooltip
              placement="bottomLeft"
              title={
                <span style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{text}</span>
              }
            >
              <span className="text-ellipsis"> {labels.map((t) => t.name).join(', ')}</span>
            </Tooltip>
          );
        },
      },
    ],
    [
      'targets',
      {
        label: 'targets',
        title: renderColTitle(translate('incidents.detail.share.targets'), 'targets'),
        dataIndex: 'targets',
        width: 320,
        ellipsis: {
          showTitle: false,
        },
        showSorterTooltip: false,
        sorter: true,
        render: (targets: string[]) => {
          if (!targets.length) return null;
          return (
            <Tooltip
              placement="bottomLeft"
              title={
                <span style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                  {targets.join(', ')}
                </span>
              }
            >
              <span className="text-ellipsis">{targets.join(', ')}</span>
            </Tooltip>
          );
        },
      },
    ],
    [
      'perpetrators',
      {
        label: 'perpetrators',
        title: renderColTitle(translate('incidents.detail.share.perpetrators'), 'perpetrators'),
        dataIndex: 'perpetrators',
        width: 200,
        ellipsis: {
          showTitle: false,
        },
        showSorterTooltip: false,
        sorter: true,
        render: (perpetrators: string[]) => {
          if (!perpetrators.length) return null;
          return (
            <Tooltip
              placement="bottomLeft"
              title={
                <span style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                  {perpetrators.join(', ')}
                </span>
              }
            >
              <span className="text-ellipsis">{perpetrators.join(', ')}</span>
            </Tooltip>
          );
        },
      },
    ],
    [
      'actionTakens',
      {
        label: 'actionTakens',
        title: renderColTitle(translate('incidents.detail.share.taken'), 'actions_taken'),
        dataIndex: 'actions_taken',
        width: 350,
        ellipsis: {
          showTitle: false,
        },
        showSorterTooltip: false,
        sorter: true,

        render: (taken: any[]) => {
          if (!taken.length) return null;
          const text = taken.map((t) => t.name).join(', ');
          return (
            <Tooltip
              placement="bottomLeft"
              title={
                <span style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{text}</span>
              }
            >
              <span className="text-ellipsis"> {text}</span>
            </Tooltip>
          );
        },
      },
    ],
    [
      'location',
      {
        label: 'location',
        title: renderColTitle(translate('incidents.detail.share.location'), 'location'),
        dataIndex: 'location',
        width: 180,
        ellipsis: {
          showTitle: false,
        },
        showSorterTooltip: false,
        sorter: true,
        render: (location: string) => {
          if (!location) return null;
          return (
            <Tooltip
              placement="bottomLeft"
              title={
                <span style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{location}</span>
              }
            >
              <span className="text-ellipsis">{location}</span>
            </Tooltip>
          );
        },
      },
    ],
    [
      'is_survey_answered',
      {
        label: 'is_survey_answered',
        title: renderColTitle(
          translate('incidents.list.column.survey_status'),
          'is_survey_answered'
        ),
        dataIndex: 'is_survey_answered',
        width: 180,
        ellipsis: {
          showTitle: false,
        },
        showSorterTooltip: false,
        sorter: true,
        render: (is_survey_answered: boolean) => {
          const t_1 = translate('incident.list.column.anonymouse_end_chat_answered');
          const t_2 = translate('incident.list.column.anonymouse_end_chat_not_answered');
          const t_3 = translate('incident.list.column.anonymouse_end_chat_off');
          let txt_show = t_2;
          if (is_survey_answered === true) {
            txt_show = t_1;
          } else if (!surveyStatus) {
            txt_show = t_3;
          }
          return (
            <Tooltip
              placement="bottomLeft"
              title={
                <span style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{txt_show}</span>
              }
            >
              <span
                className={`text-ellipsis ${is_survey_answered === true ? 'text-bold-600' : ''}`}
              >
                {txt_show}
              </span>
            </Tooltip>
          );
        },
      },
    ],
  ]);

  const [columns, setColumns] = React.useState<any>(
    Array.isArray(filters.columns)
      ? filters.columns.map((c) => totalCols.get(c)).filter((e) => e)
      : Array.from(totalCols.values())
          .filter((e, index) => index <= 7)
          .filter(
            (col) => col && col.label !== 'updatedAtDateTime' && col.label !== 'submittedDateTime'
          )
  );

  React.useEffect(() => {
    if (isEmpty(auth.profile)) return;
    const filtersValues: IFiltersIncidentsFormValues = filtersRef.current.getFilterValues();
    const query = {
      organization_id: myOrg._id,
      search: trim(filtersValues.search),
      status: filtersValues.status,
      response_status: filtersValues.responseStatus,
      assigned_to_me: filtersValues.assigned,
      show_hidden: showHidden,
      sort_by: filters.sort_by,
      sort_order: typeof filters.sort_order === 'number' ? filters.sort_order : -1
    };
    setQuery(query);
    dispatch(
      updateIncidentFilterAction({
        incident_filter: {
          ...query,
          organization_name: myOrg?.name,
          role_name: myOrg?.role_name,
          columns: columns.map((c) => c.label),
        },
      })
    );
  }, [myOrg, showHidden, trigger]);

  React.useEffect(() => {
    const payload: IPayloadGetSettingServey = {
      onSuccess: (dataOrg) => {
        if (dataOrg) {
          let new_data_org = { ...dataOrg };
          if (!has(dataOrg, 'is_allow_servey')) {
            new_data_org['is_allow_servey'] = false;
          }
          setSurveyStatus(new_data_org.is_allow_servey);
        }
      },
      onError: () => {},
    };
    return () => {
      dispatch(getSettingServeyAction(payload));
    };
  }, [dispatch, myOrg, showHidden, trigger]);

  React.useEffect(() => {
    const moving = totalCols.get(movingCol);
    const newColumns = columns
      .filter((e) => e)
      .map((c) => {
        if (c.label === movingCol) {
          return moving;
        }
        return totalCols.get(c.label);
      });
    setColumns(newColumns);
  }, [movingCol, ascOrder, sortType]);

  React.useEffect(() => {
    return () => {
      dispatch({ type: UNMOUT_INCIDENTS_LIST });
    };
  }, []);

  const handleVisibleCreate = () => {
    setIsVisibleCreate(true);
  };

  const handleCancelVisibleCreate = () => {
    setIsVisibleCreate(false);
  };

  const onFilter = () => {
    setTrigger((pre) => pre + 1);
  };

  const onRow = (item: any, index: any) => {
    const isUnread = get(item, 'status.code', '') === 1;
    let className = index % 2 === 0 ? 'row-odd' : '';
    className = isUnread ? `${className} row-bold` : className;
    return {
      className: className,
    };
  };

  const handleClickSorter = (sorter: any) => {
    const type = sorter.field;
    const hasSort = sorter.order === 'ascend' || sorter.order === 'descend';

    const newAscOrder = sorter.order === 'ascend';
    const sortOrder = newAscOrder ? 1 : -1;

    if (hasSort) {
      setSortType(type);
      setAscOrder(newAscOrder);
    } else {
      setSortType('');
      setAscOrder(true);
    }

    const newQuery = {
      ...query,
      sort_by: hasSort ? type : '',
      sort_order: hasSort ? sortOrder : -1,
    };

    setQuery(newQuery);

    dispatch(
      updateIncidentFilterAction({
        incident_filter: {
          ...filters,
          sort_by: hasSort ? type : '',
          sort_order: hasSort ? sortOrder : -1,
        },
      })
    );
  };

  const updateColumns = (newColumns: any[]) => {
    setColumns(newColumns);
    dispatch(
      updateIncidentFilterAction({
        incident_filter: {
          ...filters,
          columns: newColumns.map((c) => c.label),
        },
      })
    );
  };
  const onDragEnd = (fromIndex, toIndex) => {
    const newColumns = [...columns];
    const item = newColumns.splice(fromIndex, 1)[0];
    newColumns.splice(toIndex, 0, item);
    updateColumns(newColumns);
  };

  const onFilterCols = (colName: string, isChecked: boolean) => {
    let newColumns: any = [];
    if (isChecked) {
      const newColumnIndex = Array.from(totalCols.values()).findIndex(
        (col: any) => col.label === colName
      );
      if (newColumnIndex < 0) return;
      newColumns = [...columns];
      newColumns.splice(newColumnIndex, 0, Array.from(totalCols.values())[newColumnIndex]);
      setColumns(newColumns);
    } else {
      newColumns = columns.filter((col: any) => {
        return col.label !== colName;
      });
    }
    setColumns(newColumns);
  };

  return (
    <div className="list-incidents">
      <Headers />
      <Filters
        onFilter={onFilter}
        handleVisibleCreate={handleVisibleCreate}
        ref={filtersRef}
        onFilterCols={onFilterCols}
        columns={columns}
      />
      {filters.columns?.length > 0 && (
        <ReactDragListView.DragColumn
          onDragEnd={onDragEnd}
          nodeSelector="th"
          handleSelector=".dragHandler"
          ignoreSelector="react-resizable-handle"
          lineClassName="drag-line"
        >
          <InfinityLoadTable
            columns={(filters?.columns || [])
              .map((c: string) => {
                if (!get(data_org_root, 'is_allow_servey', false)) {
                  if (!['anonymous_end_chat_status', 'is_end_chat'].includes(c)) {
                    return totalCols.get(c);
                  }
                  return null;
                } else {
                  return totalCols.get(c);
                }
              })
              .filter((e) => e)
              .map((col) => {
                  return withLink(col);
              })
            }
            dataSource={list}
            className="table-incident"
            onRow={onRow}
            scroll={{ x: 800, y: 'calc(100vh - 290px)' }}
            query={query}
            loadDataAction={loadingIncidentsAction}
            isLoading={isLoading}
            dataType={translate('list.empty.incident')}
            onchangeSorter={handleClickSorter}
            defaultSorter={{
              field: sortType,
              order: ascOrder ? 'ascend' : 'descend',
            }}
          />
        </ReactDragListView.DragColumn>
      )}
      {filters.columns?.length === 0 && (
        <div className="no-columns-message">
          <NoColumnsIcon />
          <span style={{ fontWeight: '500', fontSize: '21px', margin: '5px 0px 5px -20px' }}>
            {translate('incidents.list.nocolumn.des1')}
          </span>
          <span style={{ marginBottom: '10px' }}> {translate('incidents.list.nocolumn.des2')}</span>
          <Button
            size="large"
            type="primary"
            className="btn-filter-columns"
            onClick={() => {
              filtersRef.current.showFilterCols();
            }}
            icon={<FilterIcon color="white" fillOpacity={'0.9'} />}
          >
            {translate('incidents.list.nocolumn.button')}
          </Button>
        </div>
      )}
      <CreateIncidents isVisible={isVisibleCreate} onCancel={handleCancelVisibleCreate} />
    </div>
  );
};

export default React.memo(ListIncidents);
